import Base from '../base.js'
// import { statusResponse } from '../responseService'
export default class Skill extends Base {
  constructor () {
    super('/skills')
  }
}
